import React, { useState, useEffect } from "react";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import toast from "react-hot-toast";

const SendNotificationModal = ({ isOpen, onClose, notificationId, onSend }) => {
    const [sendMode, setSendMode] = useState("all");
    const [mobileNumbers, setMobileNumbers] = useState("");
    const [selectedUserTypes, setSelectedUserTypes] = useState([]);

    // Get user types from session storage
    const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType")) || [];

    // Reset state when modal closes
    useEffect(() => {
        if (!isOpen) {
            setSendMode("all");
            setMobileNumbers("");
            setSelectedUserTypes([]);
        }
    }, [isOpen]);

    const handleSubmit = () => {
        let mobile = [];
        let user_type = [];

        if (sendMode === "mobile") {
            // Parse mobile numbers from textarea (line-separated)
            mobile = mobileNumbers
                .split("\n")
                .map(num => num.trim())
                .filter(num => num.length > 0);

            if (mobile.length === 0) {
                toast.error("Please enter at least one mobile number");
                return;
            }
        } else if (sendMode === "user_type") {
            user_type = selectedUserTypes;

            if (user_type.length === 0) {
                toast.error("Please select at least one user type");
                return;
            }
        }

        // Call the send function with the appropriate data
        onSend({
            notification_id: notificationId,
            mobile: mobile,
            user_type: user_type,
        });
    };

    const handleUserTypeToggle = (userTypeValue) => {
        setSelectedUserTypes(prev => {
            if (prev.includes(userTypeValue)) {
                return prev.filter(val => val !== userTypeValue);
            } else {
                return [...prev, userTypeValue];
            }
        });
    };

    const handleClose = () => {
        onClose();
    };

    if (!isOpen) return null;

    return (
        <ModalComponent show={isOpen} setShow={handleClose} size="lg">
            <div className="p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                    Send Notification
                </h2>

                {/* Mode Selection */}
                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-900 mb-3">
                        Send To
                    </label>

                    {/* All */}
                    <div className="mb-3">
                        <label className="flex items-center cursor-pointer">
                            <input
                                type="radio"
                                name="sendMode"
                                value="all"
                                checked={sendMode === "all"}
                                onChange={(e) => setSendMode(e.target.value)}
                                className="mr-2"
                            />
                            <span className="text-sm text-gray-700">All Users</span>
                        </label>
                    </div>

                    {/* Selected Mobile */}
                    <div className="mb-3">
                        <label className="flex items-center cursor-pointer">
                            <input
                                type="radio"
                                name="sendMode"
                                value="mobile"
                                checked={sendMode === "mobile"}
                                onChange={(e) => setSendMode(e.target.value)}
                                className="mr-2"
                            />
                            <span className="text-sm text-gray-700">Selected Mobile Numbers</span>
                        </label>
                        {sendMode === "mobile" && (
                            <div className="mt-2 ml-6">
                                <textarea
                                    rows="5"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Enter mobile numbers (one per line)&#10;9876543210&#10;9876543211&#10;9876543212"
                                    value={mobileNumbers}
                                    onChange={(e) => setMobileNumbers(e.target.value)}
                                />
                                <p className="text-xs text-gray-500 mt-1">
                                    Enter one mobile number per line
                                </p>
                            </div>
                        )}
                    </div>

                    {/* Selected User Type */}
                    <div className="mb-3">
                        <label className="flex items-center cursor-pointer">
                            <input
                                type="radio"
                                name="sendMode"
                                value="user_type"
                                checked={sendMode === "user_type"}
                                onChange={(e) => setSendMode(e.target.value)}
                                className="mr-2"
                            />
                            <span className="text-sm text-gray-700">Selected User Types</span>
                        </label>
                        {sendMode === "user_type" && (
                            <div className="mt-2 ml-6 space-y-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3">
                                {appUserTypes.map((userType) => (
                                    <label
                                        key={userType.user_type_id}
                                        className="flex items-center cursor-pointer"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={selectedUserTypes.includes(userType.user_type)}
                                            onChange={() => handleUserTypeToggle(userType.user_type)}
                                            className="mr-2"
                                        />
                                        <span className="text-sm text-gray-700 capitalize">
                                            {userType.user_type}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end gap-3">
                    <button
                        onClick={handleClose}
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                    >
                        Send Notification
                    </button>
                </div>
            </div>
        </ModalComponent>
    );
};

export default SendNotificationModal;
